import LogoDarkIcon from './component'

export default LogoDarkIcon
